/**
 * Restituisce la variante CSS `.nora-status--*` per una conversazione.
 * @param {Object} conv - Oggetto conversazione con status, processState, noraIsIncluded, numeroTrasferta
 * @param {string} [status] - Status conversazione
 * @returns {string} Suffisso variante: waiting, running, ended, error, neutral
 */
export function getConversationStatusVariant(conv, status) {
  const convStatus = status ?? conv?.status
  const value = conv?.processState?.value

  // Ramo agentico: la variante viene dal DTO `ConversationExecution`, non dai
  // processi. Senza questa guardia una conversazione di Nora cadeva sul `return 'running'`
  // finale e si mostrava verde-in-corso anche quando era ferma o da riconciliare.
  if (conv?.execution?.engine === 'agent') {
    if (convStatus === 'canceled' || convStatus === 'ignored') return 'neutral'
    switch (conv.execution.status) {
      case 'error':
        return 'error'
      case 'waiting_operator':
      case 'waiting_confirmation':
        return 'waiting'
      case 'waiting_user':
        // Non è un errore e non sta lavorando: la palla è del viaggiatore, e la lista non
        // deve suggerire che qualcuno debba intervenire.
        return 'neutral'
      case 'completed':
        return 'ended'
      default:
        return 'running'
    }
  }

  if (convStatus === 'paused') return 'waiting'
  if (convStatus === 'canceled' || convStatus === 'ignored') return 'neutral'
  if (convStatus === 'ended' && conv?.numeroTrasferta) return 'ended'
  if (convStatus === 'ended') return 'ended'
  if (convStatus === 'error' && value === 3) return 'error'
  if (value === 5) return 'error'
  if (value === 3) return 'ended'
  if (value === 2 || value === 1 || value === 7) return 'running'

  return 'running'
}

/**
 * Restituisce la variante CSS `.nora-status--*` per lo stato numerico di un processo.
 * @param {number} stateValue - Valore numerico stato processo (STATE_ENUM)
 * @returns {string} Suffisso variante CSS (waiting, running, ended, error, neutral)
 */
export function getProcessStatusVariant(stateValue) {
  if (stateValue === 3) return 'ended'
  if (stateValue === 5) return 'error'
  if (stateValue === 8) return 'neutral'
  if (stateValue === 7) return 'waiting'
  if (stateValue === 2 || stateValue === 1) return 'running'
  return 'neutral'
}

/**
 * Restituisce la variante CSS `.nora-status--*` per lo stato numerico di uno step processo.
 * @param {number} stepState - Valore numerico stato step
 * @returns {string} Suffisso variante CSS
 */
export function getStepStatusVariant(stepState) {
  if (stepState === 5) return 'error'
  if (stepState === 3) return 'ended'
  return 'running'
}

/**
 * Restituisce la classe CSS `.nstep--*` per lo stato di uno step processo.
 * @param {number} stepState - Valore numerico stato step
 * @returns {string} Classe modificatore nstep (es. nstep--done)
 */
export function getStepClass(stepState) {
  if (stepState === 3) return 'nstep--done'
  if (stepState === 2) return 'nstep--active'
  if (stepState === 5) return 'nstep--error'
  return ''
}
